module.exports = __webpack_public_path__ + "files/77c38a2ea60a3f1ea446392636e9529f.png";